<template>
  <div>
    <!-- <div class="title font20">意见反馈</div> -->
    <div v-if="!success"
         class="form">
      <el-form ref="form"
               :model="form"
               :rules="rules"
               :label-width="80">
        <el-form-item label="手机号："
                      required
                      prop="phone">
          <el-input type="text"
                    maxlength="11"
                    placeholder="手机号"
                    v-model="form.phone"></el-input>
        </el-form-item>
        <el-form-item label="内容："
                      required
                      prop="problems">
          <el-input type="textarea"
                    autosize
                    placeholder="反馈内容"
                    v-model="form.problems"></el-input>
        </el-form-item>
        <el-form-item>
          <div class="flexCenter">
            <el-button type="danger"
                       @click="submitForm">提交</el-button>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <!-- <div class="title font20">我的反馈</div> -->
    <el-result v-if="success"
               icon="success"
               title="提交成功"
               subTitle="感谢您的宝贵意见,祝你生活愉快!">
      <template slot="extra">
        <el-button type="danger"
                   size="medium"
                   @click="toIndex">首页</el-button>
      </template>
    </el-result>

  </div>
</template>
<script>
import { formAddApply } from '@/api/api.js'
export default {
  data () {
    const validateMobile = (rule, value, callback) => {
      let regPhone = /^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/
      if (value === '') {
        callback(new Error('请填写手机号'));
      } else if (!regPhone.test(value)) {
        callback(new Error('请输入正确的手机号格式!'));
      } else {
        callback();
      }
    };
    return {
      rules: {
        phone: [
          { validator: validateMobile, trigger: 'blur' }
        ],
        problems: [
          { required: true, message: '请输入反馈内容', trigger: 'change' }
        ],
      },
      success: false,
      imageUrl: '',
      typeList: ['功能建议', '投诉建议', '我要举报', '其他类型'],
      contentList: ['线上平台', '零售培训', '咨询顾问', '零售圈子', '会员卡别'],
      radio1: 1,
      form: { phone: '', problems: '', fromType: '4' }
    }
  },
  methods: {
    init () {
      this.form.phone = '';
      this.form.problems = '';
      this.success = false;
    },
    toIndex () {
      if (this.$route.path != '/') {
        this.$router.push('/')
      }
      this.form.phone = '';
      this.form.problems = '';
      this.success = false;
      this.$emit('close')
    },
    submitForm () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          console.log('校验通过')
          this.getformAddApply()
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    async getformAddApply () {
      const res = await formAddApply(this.form)
      if (res && res.code == 200) {
        console.log('成功')
        this.success = true
      } else {
        // this.success = false
      }
    },
    handleAvatarSuccess (res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload (file) {
      const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    }
  }
}
</script>
<style lang="less" scoped>
.title {
  font-weight: bold;
  color: #333;
  padding-bottom: 20px;
  border-bottom: 1px solid #e5e5e5;
}
.form {
  margin: 0 0 20px 0;
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
}
</style>